import React from 'react';
import { number, bool, string, func, oneOf } from 'prop-types';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { ChevronRightIcon } from '@snapask/common-components';
import { sendGTMEvent } from 'reduxModules/googleTagManager/action';
import useStyles from 'hooks/useStyles';
import Star from 'components/Star';
import styles from './RatingInfo.scss';

const RatingInfo = ({
  averageRate,
  ratingCount,
  className,
  position,
  onClick,
  eventName,
  clickable,
}) => {
  useStyles(styles);
  const { t } = useTranslation(['rating']);
  const dispatch = useDispatch();

  const handleOnClick = () => {
    if (eventName) {
      dispatch(
        sendGTMEvent({
          eventName,
        }),
      );
    }
    if (typeof onClick === 'function') onClick();
  };

  return (
    <div
      className={cx(styles.root, className, { [styles.hasCursor]: clickable })}
      onClick={handleOnClick}
    >
      <Star
        svgSize={20}
        type={position === 'OVERVIEW' ? 'DARK_FILLED' : 'FILLED'}
        className={styles.star}
      />
      {averageRate}
      <span className={styles.dot} />
      {ratingCount > 1
        ? t('common.reviewDisplay.reviewOverviewPlural', {
            review: ratingCount,
          })
        : t('common.reviewDisplay.reviewOverviewSingular', {
            review: ratingCount,
          })}
      {position === 'OVERVIEW' && (
        <ChevronRightIcon className={styles.chevron} />
      )}
    </div>
  );
};

RatingInfo.propTypes = {
  averageRate: number,
  ratingCount: number,
  position: oneOf(['OVERVIEW', 'RATING']),
  className: string,
  onClick: func,
  eventName: string,
  clickable: bool,
};

RatingInfo.defaultProps = {
  averageRate: 0,
  ratingCount: 0,
  position: 'RATING',
  className: '',
  onClick: () => {},
  eventName: '',
  clickable: true,
};

export default RatingInfo;
